import React from 'react';
import Modal from '../Modal';

import { Box, Img, NoButton, Text, Title, WrapButton, YesButton } from './AllertFinance.styled';

import Image from '../../../images/AllertFinance.png'

import { useNavigate } from 'react-router-dom';



const AllertFinance = ({ onClose, }) => {

  const navigate=useNavigate()


  return (
    <Modal onClose={onClose}>
      <Box>
        <Img src={Image} alt="Вихід" />
        <Title>Ви не заповнили реквізити</Title>
        <Text>Щоб виставити диво-кошики на продаж, додайте банківські реквізити у вкладці «Фінанси». Поки це не буде зроблено, продаж кошиків неможливий.</Text>
        <WrapButton>

          <YesButton
            onClick={() => { navigate('/financial') }}>Перейти у «Фінанси»</YesButton>

        </WrapButton>
      </Box>

    </Modal>
  );
};

export default AllertFinance;
